import { render, staticRenderFns } from "./WelcomeBanner.vue?vue&type=template&id=306b7162&scoped=true"
import script from "./WelcomeBanner.vue?vue&type=script&lang=js"
export * from "./WelcomeBanner.vue?vue&type=script&lang=js"
import style0 from "./WelcomeBanner.vue?vue&type=style&index=0&id=306b7162&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306b7162",
  null
  
)

export default component.exports